module.exports = __webpack_public_path__ + "img/196.1e9a31e2.jpg";